
import {
  postFakeLogin,
} from "../../../helpers/FakeBackendHelper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './Reducer';
import {login} from "../../veloxity/auth/LoginReducer";
import {logout} from "../../veloxity/auth/LogoutReducer";


const getClientId = () => {
  let clientId = localStorage.getItem('client_id');
  if (!clientId) {
    clientId = generateClientId(); 
    localStorage.setItem('client_id', clientId);
  }
  return clientId;
};

const generateClientId = () => {
  return (
    Math.random().toString(36).substring(2, 16) +
    Math.random().toString(36).substring(2, 16)
  );
};

export const loginUser = (user, history) => async (dispatch) => {
  try {
    const clientId = getClientId();
    const response = await dispatch(login({
      email: user.email,
      password: user.password,
      headers: {
        'Device-Id': clientId
      }
    }));

    const data = await response.payload;

    if (data && data.status) {
      sessionStorage.setItem("authUser", JSON.stringify(data));
      dispatch(loginSuccess(data));
      history('/dashboard');
    } else {
      dispatch(apiError(response.status));
    }
  } catch (error) {
    dispatch(apiError("An unexpected error occurred"));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {

    //await dispatch(logout());

    await sessionStorage.removeItem("authUser");

    await dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};


export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};